import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import Categories from "./components/Categories";
import Rank from "./components/Rank";
import NewReleases from "./components/NewReleases";
import About from "./components/About";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Featured />
        <Categories />
        <Rank />
        <NewReleases />
        <About />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}